import { EXISTED_STATSIG_AB_TESTS } from '../../constants/ab-tests/ab-tests';
import useStatsigVariant from './use-statsig-variant';

// AB TEST - 1596 (remove on either accept or reject)
// Read only where the test applies (a MaterialLabels variant with maxLabels above one) and the card has two or more
// labels: A and B look the same everywhere else, so nothing else may log an exposure
const useTwoBadgesCoexistenceABTest = (hasCombinedLabels: boolean): boolean =>
    useStatsigVariant(EXISTED_STATSIG_AB_TESTS.twoBadgesCoexistence, undefined, hasCombinedLabels) === 'B';

export default useTwoBadgesCoexistenceABTest;
